// @flow
import React from 'react';

type Props = {
    listing: {
        propertyType: string,
        geoDistance: {
            text: string,
            relationType: string
        } | null,
        address?: {
            city: string,
            stateProvince: string
        }
    }
};

const GeoDetails = ({listing}: Props) => {
    const {propertyType, geoDistance} = listing;
    const text = geoDistance ? geoDistance.text : '';

    return (
        <div className="HitExperimentInfo__type-place-details">
            {!!propertyType && <span>{propertyType}</span>}
            {!!text && <span>{text}</span>}
        </div>
    );
};

const AddressDetails = ({listing}: Props) => {
    const {propertyType, address = {}} = listing;
    const {city, stateProvince} = address;

    return (
        <div className="HitExperimentInfo__type-place-details">
            {!!propertyType && <span>{propertyType}</span>}
            {!!city && (
                <span>
                    {city} {stateProvince && `, ${stateProvince}`}
                </span>
            )}
        </div>
    );
};

export {GeoDetails, AddressDetails};
